import streamitMark from '../assets/streamit-mark.png';
import slcMark from '../assets/slc-mark.png';

/** Decorative beside the product name; the surrounding control owns its label. */
export function BrandMark({ product = 'streamit', size = 36, className }: {
  product?: 'streamit' | 'slc'; size?: number; className?: string;
}) {
  return <img src={product === 'slc' ? slcMark : streamitMark} alt="" aria-hidden="true"
    width={size} height={size} className={className} style={{ objectFit: 'contain', flexShrink: 0, display: 'inline-block', verticalAlign: 'middle' }} />;
}
